module.exports = __webpack_public_path__ + "img/accept_call.97254612.svg";